module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Eiken-6cecedefe0dab81b76218da4f549d773.svg";